import React from 'react'
// libs
import styled from 'styled-components'
// components
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
// types
import { SvgIconProps } from '@mui/material'

const KeyboardArrowUp = styled(KeyboardArrowUpIcon)`
  && {
    cursor: pointer;
  }
`

const KeyboardArrowDown = styled(KeyboardArrowDownIcon)`
  && {
    cursor: pointer;
  }
`

interface Props extends SvgIconProps {
  collapsed: boolean
}

const CollapseIcon: React.FC<Props> = ({ collapsed, ...rest }) => {
  return collapsed ? <KeyboardArrowUp {...rest} /> : <KeyboardArrowDown {...rest} />
}

export default CollapseIcon
